<template>
  <v-dialog v-model="dialog" max-width="1000px" persistent>
    <v-container grid-list-md px-0 py-0>
      <v-card>
        <v-card-title class="pb-0">
          <span class="headline">Pedido N° {{editedItem.id}}: {{total | real}}</span>
        </v-card-title>

        <v-card-text class="pt-0">
          <v-container grid-list-md px-0 py-0>
            <v-form v-model="valid" xs12>
              <v-layout row wrap v-if="client">
                <v-flex xs12 sm6 md6>
                  <b>Nome:</b>
                  {{client.name}}
                  <br />
                  <b>End:</b>
                  {{address}}
                  <br />
                  <b>obs:</b>

                  {{obs}}
                </v-flex>
              </v-layout>
              <br />
              <br />
              <hr />
              <br />
              <br />
              <v-layout row wrap>
                <v-flex xs12 sm2 md2>
                  <v-text-field type="number" v-model="product" label="Produto"></v-text-field>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-text-field type="number" min="1" v-model="qty" label="qty"></v-text-field>
                </v-flex>
                <v-btn small color="success" @click.native="addItem">ADD</v-btn>
              </v-layout>
              <v-layout row wrap>
                <table style="width: 50%">
                  <tr>
                    <td>
                      <b>Item</b>
                    </td>
                    <td>
                      <b>Preço</b>
                    </td>
                    <td>
                      <b>Qtd</b>
                    </td>
                    <td>
                      <b>Total</b>
                    </td>
                    <td></td>
                  </tr>
                  <tr v-for="(item, i) in items" :key="i">
                    <td>{{item.id}}</td>
                    <td>{{item.price | real}}</td>
                    <td>{{item.qty}}</td>
                    <td>{{item.total | real}}</td>
                    <td>
                      <v-icon @click="removeProduct(item, i)">close</v-icon>
                    </td>
                  </tr>
                </table>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                  <v-text-field v-model="obs" label="OBS:"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout column wrap v-if="total > 0">
                <strong>Forma de Pagamento: {{total_payment | real}}</strong>
                <div style="max-width: 33%">
                  <v-select v-model="type_payment" :items="types_payment" label="Tipo" dense></v-select>
                </div>
                <div style="max-width: 33%">
                  <v-text-field
                    type="number"
                    min="0.00"
                    step="0.01"
                    :max="total"
                    v-model="value_payment"
                    label="Valor"
                  ></v-text-field>
                </div>
                <div style="max-width: 33%">
                  <v-text-field
                    type="number"
                    min="0"
                    step="1"
                    :max="type_payment_limit"
                    v-model="plots"
                    label="Parcelas"
                  ></v-text-field>
                  <v-btn
                    small
                    color="success"
                    v-if="total_payment != total"
                    @click.native="addItemPayment"
                  >ADD</v-btn>
                </div>
              </v-layout>
              <v-layout row wrap>
                <table style="width: 50%">
                  <tr>
                    <td>
                      <b>Tipo</b>
                    </td>
                    <td>
                      <b>Valor</b>
                    </td>
                    <td>
                      <b>Parcelas</b>
                    </td>
                    <td></td>
                  </tr>
                  <tr v-for="(item, i) in items_payment" :key="i">
                    <td>{{item.type}}</td>
                    <td>{{item.value | real}}</td>
                    <td>{{item.plots}}</td>
                    <td>
                      <v-icon @click="removePayment(item, i)">close</v-icon>
                    </td>
                  </tr>
                </table>
              </v-layout>
            </v-form>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="gray" flat @click.native="close">Fechar</v-btn>
              <v-btn color="primary" @click.native="save" :disabled="!valid">SALVAR</v-btn>
            </v-card-actions>
          </v-container>
        </v-card-text>
      </v-card>
    </v-container>
  </v-dialog>
</template>
<script>
import moment from "moment";
import axios from "axios";
import { mask } from "vue-the-mask";
export default {
  props: ["active", "finish", "item", "category"],
  directives: {
    mask,
  },

  data() {
    let edited = {};

    if (this.item.id) {
      edited = this.item;
    }

    return {
      valid: false,
      client: null,
      session: false,
      dark: false,
      name: null,
      phone: null,
      address: null,
      newAddress: false,
      mask: "(##) #####-####",
      items: [],
      obs: null,
      product: null,
      qty: null,
      total: 0,
      total_payment: 0,
      items_payment: [],
      type_payment: null,
      types_payment: [],
      value_payment: 0,
      type_payment_limit: 1,
      plots: 1,
      dialog: this.active,
      editedItem: edited,
    };
  },
  filters: {
    real: function (value) {
      if (!value) return "";
      //value = value.toPrecision(2);
      //value = value.toString().replace(".", ",");

      let val = (value / 1).toFixed(2).replace(".", ",");
      val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

      return `R$ ${val}`;
    },
    phone: function () {
      //console.log("PHONE", this.phone.length);
      if (this.phone.length == 15) {
        this.getClient();
      }
    },
    type_payment: function (value) {
      this.type_payment_limit = value.max_plots;
    },
  },
  watch: {
    dialog(val) {
      if (!val && this.finish) {
        this.finish();
      }
    },
  },
  created() {
    this.getTypesPayment();
    this.getOrder();
    console.log(this.editedItem);
  },
  methods: {
    close() {
      this.dialog = false;
    },
    getOrder() {
      this.$http
        .get(`/orders/${this.editedItem.id}`)
        .then((response) => response.data)
        .then((json) => {
          setTimeout(() => {
            console.log("DATA", json);
            this.client = json.client;
            this.name = json.client.name;
            this.phone = json.client.phone;
            this.address = json.order.address;
            this.obs = json.order.obs;
            this.total = parseFloat(json.order.total).toFixed(2);

            console.log("PHONE", this.phone);

            const arr = [];
            json.items_order.forEach((o) => {
              arr.push({
                id: o.product_id,
                price: parseFloat(o.price).toFixed(2),
                qty: o.qty,
                total: parseFloat(o.total).toFixed(2),
                cost: parseFloat(o.cost).toFixed(2),
                total_cost: parseFloat(o.qty * o.cost).toFixed(2),
              });
            });

            console.log("types_payment", this.types_payment);

            this.value_payment = this.total;
            this.total_payment = this.total;
            this.items = arr;

            const arr_b = [];
            json.item_payment.forEach((o) => {
              arr_b.push({
                id: o.id,
                type: o.type,
                type_code: o.type_payment_id,
                value: o.total,
                plots: o.plots,
              });
            });


            this.items_payment = arr_b;
          }, 1000);
        })
        .catch(() => (this.loading = false));
    },
    addAddress() {
      this.newAddress = !this.newAddress;

      if (!this.newAddress) {
        this.address = null;
      }
    },
    getTypesPayment() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        this.$http
          .get(`/type_payments/list`)
          .then((response) => response.data)
          .then((json) => {
            setTimeout(() => {
              const arr = [];
              json.items.forEach((o) => {
                arr.push({
                  value: o,
                  text: o.name,
                  max_plots: o.max_plots,
                });
              });
              this.types_payment = arr;
            }, 1000);
          })
          .catch(() => (this.loading = false));
      });
    },
    addItem() {
      this.$http
        .get(`/products/${this.product}`)
        .then((response) => response.data)
        .then((json) => {
          setTimeout(() => {
            this.loading = false;
            this.items.push({
              id: this.product,
              price: parseFloat(json.price).toFixed(2),
              qty: this.qty,
              total: parseFloat(this.qty * json.price).toFixed(2),
              cost: parseFloat(json.cost).toFixed(2),
              total_cost: parseFloat(this.qty * json.cost).toFixed(2),
            });

            let soma =  parseFloat(this.qty * json.price).toFixed(2);
            this.total = parseFloat(this.total).toFixed(2);

            console.log("TOTAL", this.total);
            console.log("SOMA", soma);

            this.total = parseFloat(soma) + parseFloat(this.total);

            this.total.toFixed(2);
            this.value_payment = this.total.toFixed(2);

            this.items_payment = [];
      this.total_payment = 0;

            //console.log(json);
          }, 1000);
        })
        .catch(() => {
          this.product = null;
          this.$notify({
            title: `Produto não encontrado!`,
            type: "error",
          });
        });
    },
    addItemPayment() {
      let id = this.type_payment.id;
      let type = this.type_payment.name;
      let type_code = this.type_payment.type;
      let value = parseFloat(this.value_payment);
      let plots = this.plots;

      let TOTAL = parseFloat(this.total).toFixed(2);

      let TMPVALUE = this.total_payment + value;

      if (TMPVALUE > TOTAL) {
        value = TOTAL - parseFloat(this.total_payment);
        this.total_payment = TOTAL;
      } else {
        this.total_payment = parseFloat(this.total_payment + value);
      }
      this.items_payment.push({
        id: id,
        type: type,
        type_code: type_code,
        value: value,
        plots: plots,
      });
      this.total = parseFloat(TOTAL).toFixed(2);
      //console.log(TOTAL, this.total_payment);
    },
    removeProduct(item, i) {
      this.total -= parseFloat(item.total);
      this.items.splice(i, 1);
      this.items_payment = [];
      this.total_payment = 0;
    },
    removePayment(item, i) {
      this.total_payment -= parseFloat(item.value);
      this.items_payment.splice(i, 1);
    },
    getClient() {
      this.$http
        .get(`/clients/phone/${this.phone}`)
        .then((response) => response.data)
        .then((json) => {
          setTimeout(() => {
            this.loading = false;
            this.client = json;

            //console.log(json);
          }, 1000);
        })
        .catch(() => (this.client = null));
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    save() {
      let data = {
        client: this.client,
        name: this.name,
        phone: this.phone,
        address: this.address,
        obs: this.obs,
        order_items: this.items,
        payment_items: this.items_payment,
      };

      this.$http
        .put(`/orders/${this.editedItem.id}`, data)
        .then((response) => response.data)
        .then((json) => {
          this.$notify({
            title: `Pedido adicionado com sucesso!`,
            type: "success",
          });
        })
        .catch((err) => {
          this.$notify({
            duration: 15000,
            title: `Erro ao Adicionar Produto!`,
            text: err.response,
            type: "error",
          });
        });
this.dialog = false;
      console.log(data);
    },
  },
};
</script>
